module.exports = __webpack_public_path__ + "img/icon_stone_wood.b0c302d.svg";